<template>
  <div>
    <!-- <player :source.sync="liveStreamDetail.streamDetail.watchURL" /> -->
    <!-- <div id='live-video'></div> -->
    <!-- <div class="text-right">

        <v-btn
          class="ml-auto px-5 subtitle-1"
          color="error"
          dark
          rounded
         
        >
          <v-icon left>mdi-phone-hangup</v-icon>End Broadcast
        </v-btn>
    </div>-->
    <v-dialog
      v-model="isLiveConsoleDialogOpen"
      scrollable
      fullscreen
      hide-overlay
      content-class="dialogLiveConsole"
      transition="dialog-bottom-transition"
    >
      <v-card color="#F8F8FA">
        <div class="header-label logo">
          <v-row>
            <v-col :cols="6" :lg="6" :md="6" :sm="6">
              <span
                icon
                @click="closeLiveConsoleDialogAndClearStep"
                class="btn-back"
              >
                <v-icon size="30">mdi-arrow-left</v-icon>

                <img :src="logoCompany" class="logo-nerdof" />
              </span>
            </v-col>
            <v-col
              :cols="6"
              :lg="6"
              :md="6"
              :sm="6"
              class="text-right align-self-center"
            >
              <v-btn
                class="end_boardcast"
                color="error"
                dark
                rounded
                height="33px"
                @click="openDeleteDialog"
              >
                <v-icon left>mdi-phone-hangup</v-icon>End Broadcast
              </v-btn>
            </v-col>
          </v-row>
        </div>
        <div class="scrollable">
          <div class="page-card">
            <div class="container-section">
              <div class="pr-7 pl-7 pt-3 main-section">
                <div class="player-container">
                  <v-row no-gutters>
                    <v-col :cols="12" :lg="8" :md="8" :sm="12">
                      <!-- <div id='video'></div> -->
                      <player v-if="watchURL" :source.sync="watchURL" />
                      <div id="video"></div>
                    </v-col>
                    <v-col :cols="12" :lg="4" :md="4" :sm="12">
                      <div flat class="pa-8">
                        <info
                          :title.sync="liveStreamDetail.title"
                          :displayName.sync="
                            liveStreamDetail.created_by.displayName
                          "
                          :displayImage.sync="liveStreamDetail.created_by.image"
                          :startTime.sync="liveStreamDetail.startTime"
                          :endTime.sync="liveStreamDetail.endTime"
                          :urlServer.sync="rtmpUrl"
                          :streamKey.sync="
                            liveStreamDetail.streamDetail.streamId
                          "
                          :inputLiveId.sync="liveStreamDetail._id"
                          :courseId.sync="$route.query.id"
                          :refreshStream="initialize"
                        />
                      </div>
                    </v-col>
                  </v-row>
                </div>

                <div class="mt-6 live-detail">
                  <v-tabs
                    v-model="tab"
                    background-color="white"
                    class="option"
                    centered
                  >
                    <v-tabs-slider></v-tabs-slider>

                    <v-tab href="#tab-1" class="subtitle-2 tab-live-detail">
                      <v-icon class="pr-2" small>info</v-icon>Stream Setting
                    </v-tab>
                    <v-tab href="#tab-2" class="subtitle-2 tab-live-detail">
                      <v-icon class="pr-2" small>speed</v-icon>Dashboard
                    </v-tab>
                    <v-tab href="#tab-3" class="subtitle-2 tab-live-detail">
                      <v-icon class="pr-2" small>picture_as_pdf</v-icon>PDF
                      Files
                    </v-tab>
                    <v-tab href="#tab-4" class="subtitle-2 tab-live-detail">
                      <v-icon class="pr-2" small>image</v-icon>Pictures
                    </v-tab>
                    <v-tab href="#tab-5" class="subtitle-2 tab-live-detail">
                      <v-icon class="pr-2" small>link</v-icon>URL Links
                    </v-tab>
                    <v-tab href="#tab-6" class="subtitle-2 tab-live-detail">
                      <v-icon class="pr-2" small>mdi-help</v-icon>Live Quiz
                    </v-tab>
                    <v-tab href="#tab-7" class="subtitle-2 tab-live-detail">
                      <v-icon class="pr-2" small>mdi-account-check</v-icon>Name
                      Check
                    </v-tab>
                    <v-tab href="#tab-8" class="subtitle-2 tab-live-detail">
                      <v-icon class="pr-2" small>mdi-poll</v-icon>Poll
                    </v-tab>
                    <v-tab href="#tab-9" class="subtitle-2 tab-live-detail">
                      <v-icon class="pr-2" small>mdi-account-multiple</v-icon
                      >Participant
                    </v-tab>
                    <v-tab href="#tab-10" class="subtitle-2 tab-live-detail">
                      <v-icon class="pr-2" small>mdi-bell-ring</v-icon>Send
                      Notification
                    </v-tab>
                  </v-tabs>

                  <v-tabs-items v-model="tab" class="live-detail-content">
                    <v-tab-item key="1" value="tab-1">
                      <div flat class="pa-8">
                        <streamSetting
                          :title.sync="liveStreamDetail.title"
                          :displayName.sync="
                            liveStreamDetail.created_by.displayName
                          "
                          :displayImage.sync="liveStreamDetail.created_by.image"
                          :startTime.sync="liveStreamDetail.startTime"
                          :endTime.sync="liveStreamDetail.endTime"
                          :urlServer.sync="rtmpUrl"
                          :streamKey.sync="
                            liveStreamDetail.streamDetail.streamId
                          "
                          :statusLive.sync="liveStreamDetail.statusLive"
                        />
                      </div>
                    </v-tab-item>
                    <v-tab-item key="2" value="tab-2">
                      <div flat class="pa-8">
                        <dashboard :liveId.sync="liveId" />
                      </div>
                    </v-tab-item>
                    <v-tab-item key="3" value="tab-3">
                      <div flat class="pa-8">
                        <pdf :liveId.sync="liveStreamDetail._id" />
                      </div>
                    </v-tab-item>
                    <v-tab-item key="4" value="tab-4">
                      <div flat class="pa-8">
                        <imageLive
                          :images.sync="liveStreamDetail.images"
                          :liveId.sync="liveStreamDetail._id"
                        />
                      </div>
                    </v-tab-item>
                    <v-tab-item key="5" value="tab-5">
                      <div flat class="pa-8">
                        <URLLink :liveId.sync="liveId" />
                      </div>
                    </v-tab-item>
                    <v-tab-item key="6" value="tab-6">
                      <div flat class="pa-5">
                        <LiveQuiz :liveId.sync="liveStreamDetail._id" />
                      </div>
                    </v-tab-item>
                    <v-tab-item key="7" value="tab-7">
                      <div flat class="pa-8">
                        <checkName :liveId.sync="liveStreamDetail._id" />
                      </div>
                    </v-tab-item>
                    <v-tab-item key="8" value="tab-8">
                      <div flat class="pa-5">
                        <poll
                          :idLive.sync="liveStreamDetail._id"
                          :setParentLoading="setLoading"
                        />
                        <!-- v-for="poll in polls" -->
                      </div>
                    </v-tab-item>
                    <v-tab-item key="9" value="tab-9">
                      <div flat class="pa-8">
                        <participant
                          :courseId.sync="liveStreamDetail.course"
                          :liveId.sync="liveStreamDetail._id"
                        />
                      </div>
                    </v-tab-item>
                    <v-tab-item key="10" value="tab-10">
                      <div flat class="pa-8">
                        <liveNotification
                          :courseId.sync="liveStreamDetail.course"
                          :liveId.sync="liveStreamDetail._id"
                          :liveStartTime.sync="liveStreamDetail.startTime"
                          :liveEndTime.sync="liveStreamDetail.endTime"
                        />
                      </div>
                    </v-tab-item>
                  </v-tabs-items>
                </div>
              </div>
              <div class="pa-0 chat-section">
                <div class="mb-3 chat-container" v-if="isLiveChatShow">
                  <div class="header-option">
                    <v-col class="menu-title">
                      <div
                        class="pa-0 title font-weight-medium liveChatText"
                        :cols="12"
                        :lg="5"
                        :md="5"
                        :sm="5"
                      >
                        Live Chat
                      </div>
                      <!-- <v-col class="pa-0 subtitle-2 font-weight-thin"
                        >อ่านความคิดเห็นและส่งข้อความถึงผู้ชม</v-col
                      > -->
                      <div
                        class="pa-0 subtitle-2 font-weight-thin"
                        :cols="12"
                        :lg="7"
                        :md="7"
                        :sm="7"
                      >
                        <v-menu
                          offset-y
                          v-if="selectedRoom"
                          v-model="menuStatus"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              rounded
                              v-bind="attrs"
                              v-on="on"
                              elevation="0"
                              @click="toggleRoomList"
                              :class="[
                                selectedRoom.mainRoom
                                  ? 'toggleListbtn main'
                                  : 'toggleListbtn',
                              ]"
                            >
                              <div
                                :class="[
                                  selectedRoom.mainRoom
                                    ? 'selectedRoomTitle main'
                                    : 'selectedRoomTitle',
                                ]"
                              >
                                {{ selectedRoom.title }}
                              </div>

                              <span class="toggleIcon">
                                <v-icon
                                  v-if="showRoomListStatus"
                                  color="#000000"
                                  right
                                  >mdi-chevron-up</v-icon
                                >
                                <v-icon v-else color="#000000" right
                                  >mdi-chevron-down</v-icon
                                >
                              </span>
                            </v-btn>
                          </template>
                          <div></div>
                          <div class="pa-0 roomListContainer">
                            <div
                              v-for="(item, index) in roomList"
                              :key="index"
                              class="pa-0 roomList-cell"
                            >
                              <div
                                @click="changeRoom(item)"
                                class="roomListTitle"
                              >
                                <div
                                  class="roomList select"
                                  v-if="selectedRoom._id == item._id"
                                >
                                  {{ item.title }}
                                </div>
                                <div class="roomList" v-else>
                                  {{ item.title }}
                                </div>
                                <div class="divider"></div>
                              </div>
                            </div>
                            <div class="pa-0 roomList-cell">
                              <div
                                @click="openInsertRoomDialog"
                                class="roomListTitle"
                              >
                                <div class="roomList addRoom">
                                  <v-icon left color="#4a90e2" size="15"
                                    >mdi-plus</v-icon
                                  >
                                  Add Room
                                </div>
                              </div>
                            </div>
                          </div>
                        </v-menu>
                        <v-btn
                          dark
                          rounded
                          height="36px"
                          @click="openEditRoomDialog"
                          elevation="0"
                          v-if="!selectedRoom.mainRoom"
                          class="
                            pl-5
                            pr-5
                            xs-full-width
                            font-weight-light
                            button-primary
                            white--text
                          "
                        >
                          <!-- <v-icon left>mdi-plus</v-icon> -->
                          Edit
                        </v-btn>
                      </div>
                    </v-col>
                  </div>
                  <div class="option-content">
                    <chat :chatRoom.sync="chatRoom" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </v-card>
    </v-dialog>
    <insert-chat-room-dialog
      :isRoomOpen.sync="editRoomDialogStatus"
      :isRoomClose="closeRoomDialog"
      :liveId.sync="liveId"
      :room.sync="roomDetail"
    ></insert-chat-room-dialog>
    <v-dialog v-model="deleteDialogStatus" persistent max-width="450">
      <v-card>
        <v-card-title class="headline">{{
          $vuetify.lang.t('$vuetify.courseManagement.live.confirmStopLive')
        }}</v-card-title>
        <v-card-text>{{
          $vuetify.lang.t(
            '$vuetify.courseManagement.live.confirmStopLiveDetail'
          )
        }}</v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="grey darken-1"
            class="px-9 ma-2 font-weight-light"
            dark
            outlined
            @click="stopStreamDialog"
            >{{
              $vuetify.lang.t(
                '$vuetify.courseManagement.liveStep.addLiveDialog.cancel'
              )
            }}</v-btn
          >
          <v-btn
            class="px-10 ma-2 font-weight-light"
            color="error darken-1"
            dark
            @click="stopStream"
            >{{
              $vuetify.lang.t(
                '$vuetify.courseManagement.liveStep.addLiveDialog.confirm'
              )
            }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
// import { videoPlayer } from "vue-video-player";
// import { insertChoice, updateChoice } from '@/service/course/exam.js';

import chat from '@/components/live/chat.vue';
import participant from '@/components/live/tab/participant.vue';
import {
  getLiveDetail,
  stopLiveStream,
  getChatRoomList,
} from '@/service/course/livev2';
import {
  getListPoll,
  insertPoll,
  votePoll,
  deletePoll,
  updatePoll,
  // insertChoice,
  deleteChoice,
} from '@/service/course/poll.js';
import liveNotification from '@/components/live/tab/liveNotification.vue';
import checkName from '@/components/live/tab/checkName.vue';
import player from '@/components/live/player.vue';
import info from '@/components/live/tab/info.vue';
import streamSetting from '@/components/live/tab/streamSetting.vue';
import pdf from '@/components/live/tab/pdf.vue';
import dashboard from '@/components/live/tab/dashboard_new.vue';
import URLLink from '@/components/live/tab/URLLink.vue';
import imageLive from '@/components/live/tab/imageLive.vue';
import LiveQuiz from '@/components/live/tab/liveQuiz.vue';
import insertChatRoomDialog from '@/components/live/dialog/insertChatRoomDialog.vue';
import poll from '@/components/live/tab/poll.vue';
import { environment } from '../../service/environment';

export default {
  props: {
    openDialog: {
      type: Boolean,
    },
    liveId: {
      type: String,
    },
    changeStep: {
      type: Function,
    },
    isLiveConsoleDialogOpen: {
      type: Boolean,
    },
    closeLiveConsoleDialog: {
      type: Function,
    },
    courseId: {
      type: String,
    },
  },
  components: {
    // videoPlayer
    player,
    chat,
    checkName,
    info,
    participant,
    dashboard,
    URLLink,
    imageLive,
    pdf,
    streamSetting,
    LiveQuiz,
    insertChatRoomDialog,
    poll,
    liveNotification,
  },
  data() {
    return {
      polls: [],
      idLiveStream: this.liveId,
      dialogAddPoll: false,
      rtmpUrl: '',

      type: 'text',
      edit: null,

      page: 1,
      isLiveChatShow: true,
      isLiveQShow: false,
      isNameCheckShow: false,
      isParticipantShow: false,
      isLivePollShow: false,
      tab: null,
      data: [],

      liveStreamDetail: null,

      openLiveConsoleDialog: false,
      deleteDialogStatus: false,

      editRoomDialogStatus: false,
      roomDetail: null,
      roomList: [],
      showRoomListStatus: false,
      selectedRoom: null,
      chatRoom: null,
      menuStatus: false,
      watchURL: null,
      loading: false,
    };
  },
  // watch: {
  //   openDialog(val){
  //     if(!val){
  //       this.clearPlayer()
  //     }
  //   }
  // },
  beforeDestroy() {
    try {
      window.jwplayer('video').remove();
    } catch (err) {
      console.log(err);
    }
  },
  // watch: {
  //   openDialog(val){
  //     console.log("yes")
  //     if(!val){
  //       this.initialize()
  //     }
  //   }
  // },
  computed: {
    logoCompany() {
      let companyDetail = localStorage.getItem('company');
      let jsonDetail = JSON.parse(companyDetail);
      return jsonDetail.companies[0].coverImg;
    },
  },
  watch: {
    menuStatus(show) {
      if (this.showRoomListStatus == true && !show) {
        this.toggleRoomList();
      }
    },
    // isLiveConsoleDialogOpen: async function(value) {
    //   if (value) {
    //       this.step = 3;
    //       this.openLiveConsoleDialog = true
    //   }
    // }
  },
  async beforeMount() {
    // this.liveStreamDetail = await getLiveDetail(this.liveId);
    // console.log(this.liveStreamDetail)
    // await this.getRoomList();
    // this.chatRoom = `${this.courseId}/${this.liveStreamDetail.chatRoom}`
    // console.log("yes")
  },
  async mounted() {
    await this.initialize();
  },
  methods: {
    setLoading(flag) {
      this.loading = flag;
    },
    async initialize() {
      this.liveStreamDetail = await getLiveDetail(this.liveId);

      // console.log(this.liveStreamDetail)
      await this.getRoomList();
      // setTimeout(function() {
      //   $('#containerChat').scrollTop($('#containerChat')[0].scrollHeight);
      // }, 100);

      // let streamKeysResult = await getLiveDetail(this.liveId);
      // console.log(streamKeysResult.streamDetail)
      // this.liveStreamDetail = await getLiveDetail(this.liveId);
      console.log(this.liveStreamDetail);
      this.rtmpUrl = environment.rtmpUrl;
      // this.watchURL = `${environment.streamUrl}${this.liveStreamDetail.streamDetail.streamId}`
      this.watchURL = `${this.liveStreamDetail.streamDetail.watchURL}?token=xyz`;
      // console.log(this.watchURL)
      // await this.getRoomList();
      // await window.jwplayer("video").setup({
      //     sources: [{file:this.liveStreamDetail.streamDetail.watchURL}],
      //     width: "100%",
      //   })
      // this.liveStreamDetail.streamDetail.rtmpUrlDomain = `${environment.rtmpUrl}`;
      // this.liveStreamDetail.streamDetail.watchURL = `${environment.streamUrl}/${this.liveStreamDetail.streamDetail.streamId}`
      // await window.jwplayer('live-video').setup({
      //   // sources: [{ file: this.liveStreamDetail.streamDetail.watchURL }],
      //   sources: [
      //     {
      //       file: `${environment.streamUrl}/${this.liveStreamDetail.streamDetail.streamId}`,
      //     },
      //   ],
      //   width: '100%',
      // });
    },
    editPoll() {
      this.dialogAddPoll = true;
    },
    openEditRoomDialog() {
      this.roomDetail = this.selectedRoom;
      this.editRoomDialogStatus = true;
    },
    openInsertRoomDialog() {
      this.roomDetail = null;
      this.editRoomDialogStatus = true;
    },
    async closeRoomDialog() {
      this.editRoomDialogStatus = false;
      // this.roomDetail = null;
      await this.getRoomList();
    },
    async getRoomList() {
      let roomListResult = await getChatRoomList({
        idlivestream: this.liveId,
      });
      // console.log(this.liveStreamDetail)
      let mainRoom = {
        // created_at: 1614567104871,
        isLive: true,
        livestream: this.liveId,
        title: 'Main room',
        mainRoom: true,
        chatRoom: `/courses/${this.liveStreamDetail.course}${this.liveStreamDetail.chatRoom}`,
        // _id: "603c56c0c67c044f9ccf762b"
      };

      if (!this.selectedRoom) {
        this.selectedRoom = mainRoom;
        this.chatRoom = mainRoom.chatRoom;
      }

      //#region create room list with chatroom
      let roomListWithChatRoom = [];
      for (let room of roomListResult) {
        roomListWithChatRoom.push({
          ...room,
          chatRoom: `/courses/${this.liveStreamDetail.course}${this.liveStreamDetail.chatRoom}/room_${room._id}`,
        });
      }
      //#endregion

      this.roomList = [mainRoom, ...roomListWithChatRoom];

      if (this.selectedRoom) {
        let foundIndex = this.roomList.findIndex(
          (room) => room._id == this.selectedRoom._id
        );
        if (foundIndex > -1) {
          this.selectedRoom = this.roomList[foundIndex];
        }
      }
    },
    async toggleRoomList() {
      // this.showRoomListStatus = !this.showRoomListStatus;
      if (this.showRoomListStatus == true) {
        this.showRoomListStatus = false;
      } else if (this.showRoomListStatus == false) {
        this.showRoomListStatus = true;
      }
    },
    async changeRoom(room) {
      this.selectedRoom = room;
      this.chatRoom = room.chatRoom;
      // if(room!=null){
      this.roomDetail = room;
      // }
    },
    async stopStream() {
      // await this.cancelStream()
      let result = await stopLiveStream(this.liveId);
      if (!result.code) {
        await this.stopStreamDialog();
        await this.closeLiveConsoleDialog();
      }
    },
    openDeleteDialog() {
      this.deleteDialogStatus = true;
    },
    stopStreamDialog() {
      this.deleteDialogStatus = false;
    },
    async closeLiveConsoleDialogAndClearStep() {
      // this.step=0
      await this.closeLiveConsoleDialog();
    },

    async getPolls() {
      const res = await getListPoll({
        idlivestream: this.liveId,
        limit: 100,
        page: 1,
      });

      this.polls = res.data;
    },
  },
};
</script>

<style lang="scss">
.toggleIcon {
  // margin-left: 12px;
}
.btnLeader {
  border-radius: 0px !important;
}
.message-container {
  position: relative;
  height: 77vh;
  background-color: white;
}
.align-position {
  position: fixed;
  bottom: 0;
  width: 100%;
}
.overflowY {
  overflow-y: inherit;
}
// .message-scroll {
//   height: 80vh;
//   // overflow: hidden;
// }
.v-dialog .v-dialog--active {
  overflow: inherit;
}
// .notification-container {
//   position: absolute;
//   top: 0;
//   right: 0;
//   width: 100%;
//   display: none;
//   height: 100%;
//   // overflow: hidden;
//   background: #ebdbbf;
//   z-index: 999;
//   transform: translateX(100%);
//   -webkit-transform: translateX(100%);
// }

.selected {
  animation: slide-in 0.3s forwards;
  -webkit-animation: slide-in 0.3s forwards;
}

.dismiss {
  animation: slide-out 0.3s forwards;
  -webkit-animation: slide-out 0.3s forwards;
}

@keyframes slide-in {
  0% {
    -webkit-transform: translateX(100%);
  }
  100% {
    -webkit-transform: translateX(0%);
  }
}

@-webkit-keyframes slide-in {
  0% {
    transform: translateX(100%);
  }
  100% {
    transform: translateX(0%);
  }
}

@keyframes slide-out {
  0% {
    transform: translateX(0%);
  }
  100% {
    transform: translateX(100%);
  }
}

@-webkit-keyframes slide-out {
  0% {
    -webkit-transform: translateX(0%);
  }
  100% {
    -webkit-transform: translateX(100%);
  }
}
.q-detail {
  height: 610px;
  overflow-y: scroll;
}
.q-report {
  height: 620px;
}
.overflow-hd {
  overflow-x: hidden !important;
}
.page-card {
  border-radius: 0px !important;
  transition: transform 0.3s ease-in-out;
}

.datetime {
  padding: 15px;
  box-shadow: 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  border-radius: 30px;
  text-align: center;
  transition: box-shadow 0.3s ease-in-out;
}

.datetime:hover {
  box-shadow: 1px 1px 5px 0 rgba(0, 0, 0, 0.19);
}

.selectCourse {
  height: auto;
  border: 0px;
  padding: 15px;
  box-shadow: 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  border-radius: 30px;
  text-align: center;
  transition: box-shadow 0.3s ease-in-out;
}

.selectCourse:hover {
  box-shadow: 1px 1px 5px 0 rgba(0, 0, 0, 0.19);
}

.progress-bar {
  box-shadow: 0 3px 10px 0 rgba(0, 0, 0, 0.19);
  border-radius: 30px;
  background-color: rgba(255, 255, 255, 0.9);
}

.card {
  box-shadow: 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  border-radius: 15px;
  transition: transform 0.3s ease-in-out;
}

.option {
  transition: transform 0.3s ease-in-out;
  color: white;
  .tab-live-detail {
    &.v-tab--active {
      border: 0;
      background: #ff8f03;
    }
  }
}

.option-content {
  transition: transform 0.3s ease-in-out;
  background: white;
  border-bottom: 1px solid #eeeeef;
  border-left: 1px solid #eeeeef;
  border-right: 1px solid #eeeeef;
  height: 100%;
}
.message-detail {
  height: 85%;
  overflow-y: scroll;
  padding-top: 15px;
}
.content {
  border-radius: 10px;
  transition: transform 0.3s ease-in-out;
  background-color: #efefef;
}

.button {
  // box-shadow: 0 3px 10px 0 rgba(0, 0, 0, 0.19);
  // border-radius: 5px;
  transition: transform 0.3s ease-in-out;
  background-color: #50adde;
  color: white;
  height: 35px;
}
.cardQ {
  padding-top: 5px;
  padding-left: 30px;
  padding-right: 30px;
  padding-bottom: 12px;
}

.button:hover {
  transform: scale(0.95, 0.95);
}

.right-nav {
  transition: transform 0.3s ease-in-out;
  color: #9d9d9d;
  margin: 0;
  padding: 10px 0;
  .v-image {
    filter: grayscale(1);
    width: 50px;
  }
  i {
    color: inherit !important;
  }
  &.active {
    color: #ff8f03;
    background: white;
    .v-image {
      filter: none;
    }
  }
  &:hover {
    background: white;
    cursor: pointer;
  }
}
.v-tabs:not(.v-tabs--vertical) .v-tab {
  flex-grow: 1;
  border-right-style: solid;
  border-right-width: thin;
  border-right-color: #eeeeef;
}

.live-preview {
  background: rgba(0, 0, 0, 0.8);
  height: 500px;
  width: 100%;
  transition: transform 0.3s ease-in-out;
}

.roomList {
  // padding: 0 16px;
  font-size: 14px;
  font-weight: 300;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.43;
  letter-spacing: normal;
  text-align: center;
  color: #4a4a4a;
  padding: 10px 16px 10px 16px;
  &.select {
    font-weight: bold;
    color: #000000;
  }
  &.addRoom {
    color: #4a90e2;
  }
}
.roomListContainer {
  text-align: center;
  background-color: #ffffff;
  z-index: 1000;
  position: relative;
  .v-list-item {
    min-height: 40px;
  }
}
.roomListTitle {
  text-align: center;
}

.divider {
  width: 100%;
  height: 1px;
  // margin: 1px 0 0;
  margin: 0px;
  background-color: rgba(0, 0, 0, 0.09);
}

.live-detail {
  transition: transform 0.3s ease-in-out;
  background-image: linear-gradient(rgba(#0779e4, 0.7), rgba(#0779e4, 0.9));
  border-style: solid;
  border-width: thin;
  border-color: #eeeeef;
  border-right: unset;
  border-radius: 3px;
}

.live-detail-content {
  transition: transform 0.3s ease-in-out;
  background-color: rgba(0, 0, 0, 0.09);
  border-top-style: solid;
  border-top-width: thin;
  border-top-color: #eeeeef;
  border-right-style: solid;
  border-right-width: thin;
  border-right-color: #eeeeef;
}

.card-top {
  background-image: linear-gradient(rgba(#0779e4, 1), rgba(#0779e4, 0.7));
  color: white;
}

.card-navigation {
  background-image: linear-gradient(rgba(#0779e4, 0.7), rgba(#0779e4, 0.4));
  color: white;
}

.card-corner {
  background-image: linear-gradient(rgba(#4cbbb9, 0.8), rgba(#4cbbb9, 0.5));
  color: white;
}

.card-right {
  background-image: linear-gradient(rgba(#084177, 0.5), rgba(#084177, 0.3));
  color: white;
}

.videoPlayer {
  width: 100%;
}

.graph-card {
  box-shadow: 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  border-radius: 15px;
  transition: transform 0.3s ease-in-out;
}

.graph-card:hover {
  transform: scale(1.02, 1.02);
}
.full-width {
  width: 96%;
}
.header-option {
  background: #308ab7;
  color: white;
}
.tab-header-option {
  background: white;
  color: #000000;
  font-size: 20px !important;
}
.menu-title {
  padding-top: 10px;
  padding-bottom: 20px;
  padding-right: 10px;
  padding-left: 10px;
}
.divQ {
  padding-top: 10px;
  padding-bottom: 5px;
  padding-right: 10px;
  padding-left: 10px;
}
.v-tabs-slider-wrapper {
  height: 0px !important;
}
.player-container {
  background-color: white;
}
.chat-container {
  // position: absolute;
  // right: 0;
  // height: 100vh;
  // height: calc(100vh - 73px - 108px - 73px);
  height: 100%;
}
.tab-subtitle-2 {
  font-size: 16px !important;
  color: #4a4a4a;
}
.tab-header-container {
  padding: 14px;
}
.tab-header-text {
  font-size: 16px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #ffffff;
}
.tab-header-option-text {
  font-size: 20px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #000000;
}
.btn-add-question {
  min-width: 30px !important;
  padding: 0px !important;
}
.question-list-container {
  box-shadow: 0 1px 0 0 #dcdcdc;
  background-color: #ffffff;
  border-radius: 2px;
  border: solid 1px #dcdcdc;
}
.question-detail {
  padding: 20px;
  font-size: 14px;
  line-break: anywhere;
}
.question-no {
  font-weight: bold;
  color: #4a90e2;
}
.question-list-text {
  color: rgba(0, 0, 0, 0.85);
}
.align-right {
  margin-top: 20px;
  text-align: right;
}
.btn-edit {
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.43;
  letter-spacing: normal;
  text-align: center;
  color: rgba(0, 0, 0, 0.65);
}
.btn-send {
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.43;
  letter-spacing: normal;
  text-align: center;
  color: #ffffff !important;
}
.pagination-align-right {
  justify-content: flex-end;
}
.header-table-report {
  border: solid 1px #dcdcdc;
  background-color: #f5f5f5;

  font-size: 14px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.43;
  letter-spacing: normal;
  text-align: center;
  color: #000000;
}
.content-table-report {
  border: solid 1px #dcdcdc;
  background-color: #ffffff;

  font-size: 14px;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.9;
  letter-spacing: normal;
  text-align: center;
  color: #000000;
}
.subcontent-table-report {
  // border: solid 1px #dcdcdc;
  // background-color: #ffffff;

  font-size: 14px;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.9;
  letter-spacing: normal;
  text-align: center;
  color: #000000;
}
.cell-table-report {
  padding: 18px;
}
.header-cell-table-report {
  padding: 18px;
}
.expand-panel-opt {
  background-color: #f3f9ff;
}
.align-center {
  align-self: center;
}
.image-center {
  margin: 0 auto;
}
.opt-ans {
  padding-top: 0px;
}
.choice-table-report {
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #000000;
}
.pagination-align-right.justify-flex-end {
  .v-pagination.theme--light {
    justify-content: flex-end;
  }
}
</style>
<style lang="scss">
.pagination-align-right {
  .v-pagination__item--active {
    background-color: #308ab7 !important;
    border-color: #308ab7 !important;
  }
}
.dialogLiveConsole {
  &.v-dialog--fullscreen {
    overflow-y: inherit;
  }
}
</style>
<style lang="scss" scoped>
// .selectedRoomTitle {
//   width: 160px;
// }
.liveChatText {
  margin-bottom: 10px;
}
.v-sheet v-sheet--tile theme--dark v-toolbar v-toolbar--flat primary {
  height: 0;
}
.sizeImgDialogAdd {
  width: 120px;
}
.v-sheet.v-sheet--tile.theme--dark.v-toolbar.v-toolbar--flat.primary {
  height: 20px !important;
}
.v-sheet.v-sheet--tile.theme--dark.v-toolbar.v-toolbar--flat.white {
  height: 20px !important;
}
.header-label {
  /* height: 40px !important; */
  background-color: #50adde;
}
.header-label.logo {
  /* min-height: 50px !important; */
  background-color: #ffffff;
  border-bottom: 1px solid #e4e4e4;
}
.header-label.logo img {
  /* height: 40px;
  vertical-align: middle;  */
}
.logo-nerdof {
  /* width: 10px; */
  padding: 4px;
  /* padding-right: 15px; */
  /* padding-left: 15px; */
  height: 44px;
  /* padding-bottom: 19.5px; */
  /* height: 100%; */
  vertical-align: middle;
  margin-top: 4px;
  margin-right: 0.5rem;
}
.btn-back {
  padding: 0px;
  height: 44px;
  align-self: center;
  margin-right: 17px;
  margin-left: 28px;
  cursor: pointer;
}
.chatRoom {
  float: right;
  margin-right: 15px;
}
.end_boardcast {
  /* margin-top: 7px; */
  font-size: 0.75rem !important;
  margin-right: 15px;
}
.scrollable {
  // overflow-y: auto;
  height: calc(100vh - 90px);
}
.align-self-center {
  align-self: center;
}
.toggleListbtn {
  font-size: 16px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #000000;
  margin-right: 20px;
  padding-left: 28px !important;
  padding-right: 22px !important;
  min-width: calc(100% - 92px);
  &.main {
    margin-right: 0px;
    min-width: 100%;
  }
}
.selectedRoomTitle {
  min-width: 160px;
  &.main {
    min-width: 239px;
  }
}
/* .container {
  background-color: #F8F8FA;
  width: 100%;
} */
.main-section {
  display: block;
  width: calc(100vw - 360px);
  overflow-y: scroll;
  height: calc(100vh - 90px);
}
.chat-section {
  width: 360px;
  height: calc(100vh - 73px);
}
.container-section {
  display: flex;
  flex-direction: row;
}

@media only screen and (max-width: 768px) {
  .main-section {
    width: 100%;
    height: 800px;
  }
  .chat-section {
    width: 100%;
    padding: 28px !important;
    height: unset;
  }
  .container-section {
    display: block;
    flex-direction: row;
  }
  .scrollable {
    overflow-y: auto;
  }
}
.roomList-cell {
  cursor: pointer;
}
</style>